/**
 * FPS counter of AJUSTES "Mostrar FPS" (GDD §13.6): a mono readout in the bottom-left corner of the view (top-left holds VIDAS, #58),
 * outside its central third, counting animation frames over half a second.
 */
export function mountFpsCounter(app: HTMLElement): { setVisible(visible: boolean): void } {
  const readout = document.createElement('p');
  readout.className = 'readout fps';
  readout.dataset.field = 'fps';
  readout.textContent = 'FPS 0';
  let frame = 0;
  let frames = 0;
  let since = 0;

  const count = (now: number) => {
    frames += 1;
    if (!since) since = now;
    if (now - since >= 500) {
      readout.textContent = `FPS ${Math.round((frames * 1000) / (now - since))}`;
      frames = 0;
      since = now;
    }
    frame = requestAnimationFrame(count);
  };

  return {
    setVisible(visible) {
      if (visible && !readout.isConnected) {
        app.append(readout);
        frames = 0;
        since = 0;
        frame = requestAnimationFrame(count);
      } else if (!visible && readout.isConnected) {
        cancelAnimationFrame(frame);
        readout.remove();
      }
    },
  };
}
